<div [formGroup]="group">
  <input type="checkbox" [id]="control.name" [value]="true" [name]="control.name" [formControlName]="control.name" (change)="onChange()" />
  <label
    [for]="control.name"
    [internalInnerHtml]="control.label"
    [userEventSource]="userEventSource"
    [ngClass]="{ 'form-label--error': formState.submitted && group.controls[control.name].errors }"
  ></label>
</div>
